<div class="flex flex-col md:flex-row min-h-screen bg-white">
  <app-sidebar
    [circleNumber]="4"
    (backClick)="goBack()"
    class="bg-teu-purple hidden sm:block relative w-full md:w-[197px] h-[120px] md:h-auto flex-shrink-0 overflow-hidden"
  >
  </app-sidebar>
  <app-header [circleNumber]="4" (backClick)="goBack()"></app-header>

  <div class="flex-1 flex flex-col">
    <app-subheader [circleNumber]="4" class="pt-[60px] md:pt-0"></app-subheader>

    <div
      class="w-full xl:max-w-[1240px] 2xl:max-w-[1300px] mx-auto xl:mx-0 px-4 sm:px-6 md:px-8 xl:px-7 pb-28 md:pb-16 xl:pb-10"
      style="padding-bottom: calc(env(safe-area-inset-bottom, 0px) + 88px)"
    >
      <h1
        class="teu-title text-2xl md:text-[32px] mb-4 md:mb-6 text-center md:text-left"
      >
        Datos adicionales
      </h1>

      <form
        [formGroup]="additionalDataForm"
        (ngSubmit)="onSubmit()"
        class="space-y-6 md:space-y-7"
      >
        <!-- Pregunta 1 -->
        <div>
          <p class="text-sm text-black mb-2">
            Los recursos que reciba de la presente operación serán utilizados
            exclusivamente para fines lícitos
          </p>
          <p-dropdown
            [options]="yesNoOptions"
            optionLabel="label"
            optionValue="value"
            formControlName="lawfulUse"
            placeholder="Seleccionar..."
            [class]="
              'w-full md:max-w-[300px]' +
              (lawfulUse?.invalid && lawfulUse?.touched
                ? ' ng-invalid ng-dirty'
                : '')
            "
          ></p-dropdown>
          <small
            *ngIf="lawfulUse?.invalid && lawfulUse?.touched"
            class="text-red-500"
          >
            {{ getErrorMessage("lawfulUse") }}
          </small>
        </div>

        <!-- Pregunta 2 -->
        <div>
          <p class="text-sm text-black mb-2">
            Bajo protesta de decir la verdad declaro que en la presente
            operación actúo en nombre y cuenta propia
          </p>
          <p-dropdown
            [options]="yesNoOptions"
            optionLabel="label"
            optionValue="value"
            formControlName="ownBehalf"
            placeholder="Seleccionar..."
            [class]="
              'w-full md:max-w-[300px]' +
              (ownBehalf?.invalid && ownBehalf?.touched
                ? ' ng-invalid ng-dirty'
                : '')
            "
          ></p-dropdown>
          <small
            *ngIf="ownBehalf?.invalid && ownBehalf?.touched"
            class="text-red-500"
          >
            {{ getErrorMessage("ownBehalf") }}
          </small>
        </div>

        <!-- Pregunta 3 -->
        <div>
          <p class="text-sm text-black mb-2">
            ¿Alguna otra persona aportará recursos para el cumplimiento de las
            obligaciones de la presente operación?
          </p>
          <p-dropdown
            [options]="yesNoOptions"
            optionLabel="label"
            optionValue="value"
            formControlName="thirdPartyResources"
            placeholder="Seleccionar..."
            [class]="
              'w-full md:max-w-[300px]' +
              (thirdPartyResources?.invalid && thirdPartyResources?.touched
                ? ' ng-invalid ng-dirty'
                : '')
            "
          ></p-dropdown>
          <small
            *ngIf="thirdPartyResources?.invalid && thirdPartyResources?.touched"
            class="text-red-500"
          >
            {{ getErrorMessage("thirdPartyResources") }}
          </small>
        </div>

        <!-- Pregunta 4 -->
        <div>
          <p class="text-sm text-black mb-2">
            ¿Usted o un familiar suyo de hasta segundo de consanguinidad o
            afinidad
            <span class="italic text-gray-500">
              (cónyuge, concubina, concubinario, abuelos, padre, madre, hijos,
              hermanas, nietos, tíos, primos hermanos, cuñados, suegros, yernos,
              nueras, hijos de su cónyuge y abuelos de su cónyuge)
            </span>
            desempeña actualmente o desempeñó durante el año inmediato anterior
            algún cargo público destacado a nivel federal, estatal o municipal o
            distritiva en México o en algún país extranjero?
          </p>
          <p-dropdown
            [options]="yesNoOptions"
            optionLabel="label"
            optionValue="value"
            formControlName="pep"
            placeholder="Seleccionar..."
            [class]="
              'w-full md:max-w-[300px]' +
              (pep?.invalid && pep?.touched ? ' ng-invalid ng-dirty' : '')
            "
          ></p-dropdown>
          <small *ngIf="pep?.invalid && pep?.touched" class="text-red-500">
            {{ getErrorMessage("pep") }}
          </small>
        </div>

        <!-- Botón Confirmar -->
        <div class="pt-4 md:pt-6 flex justify-center md:justify-start">
          <button
            type="submit"
            class="btn-primary w-full md:w-[300px] h-[46px]"
            [disabled]="additionalDataForm.invalid"
            [class]="
              'btn-primary w-full md:w-[300px] h-[46px]' +
              (additionalDataForm.invalid
                ? ' opacity-50 cursor-not-allowed'
                : '')
            "
            > Confirmar
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
